"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsDateWithinRetentionPeriodOfChangeHistory = exports.isDateGobdCompliant = void 0;
const moment_1 = __importDefault(require("moment"));
const consts_1 = require("../consts");
const validators_1 = require("./validators");
const isDateGobdCompliant = (date) => (0, moment_1.default)(date).isBetween((0, moment_1.default)().subtract(validators_1.MAX_PAST_LIMIT_YEARS, "years"), (0, moment_1.default)().add(validators_1.MAX_FUTURE_LIMIT_YEARS, "years"));
exports.isDateGobdCompliant = isDateGobdCompliant;
const checkIsDateWithinRetentionPeriodOfChangeHistory = (date) => (0, moment_1.default)(date).isBetween((0, moment_1.default)().subtract(consts_1.CHANGE_HISTORY_RETENTION_PERIOD_IN_YEARS, "years").startOf("day"), (0, moment_1.default)().endOf("day"));
exports.checkIsDateWithinRetentionPeriodOfChangeHistory = checkIsDateWithinRetentionPeriodOfChangeHistory;
